/* eslint-disable */
// @ts-nocheck
import type * as Types from '@mgp-frontend/shared/cms-graphql/domain/types';

import { gql } from '@apollo/client';
import { VerticalStepperFragmentDoc } from '../components/generated/verticalStepper';
import { ReviewsFragmentDoc } from '../components/generated/reviews';
import { SinglePriceCardFragmentDoc } from '../components/generated/singlePriceCard';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PagesSlugsQueryQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PagesSlugsQueryQuery = { __typename?: 'Query', pages?: { __typename?: 'PageEntityResponseCollection', data: Array<{ __typename?: 'PageEntity', attributes?: { __typename?: 'Page', domain: string, locale?: string | null, slug?: string | null } | null }> } | null };

export type PagesDynamicContentQueryQueryVariables = Types.Exact<{
  domain: Types.Scalars['String']['input'];
  locale: Types.Scalars['I18NLocaleCode']['input'];
  slug: Types.Scalars['String']['input'];
}>;


export type PagesDynamicContentQueryQuery = { __typename?: 'Query', pages?: { __typename?: 'PageEntityResponseCollection', data: Array<{ __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, domain: string, locale?: string | null, slug?: string | null, zoneSetup: { __typename?: 'ComponentContentBlocksZoneSetup', id: string, background?: Types.Enum_Componentcontentblockszonesetup_Background | null, container: boolean, display?: Types.Enum_Componentcontentblockszonesetup_Display | null, columnsMobile: number, columnsTablet: number, columnsDesktop?: number | null, verticalPadding?: Types.Enum_Componentcontentblockszonesetup_Verticalpadding | null, maxWidth?: Types.Enum_Componentcontentblockszonesetup_Maxwidth | null, alignText?: Types.Enum_Componentcontentblockszonesetup_Aligntext | null, position?: Types.Enum_Componentcontentblockszonesetup_Position | null, newZone: boolean, backgroundImageFull?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, name: string, url: string, mime: string } | null } | null } | null }, dynamicZone?: Array<{ __typename: 'ComponentContentBlocksAccordion', id: string, description: string, triggerClassNames?: string | null, accordionTitle: string } | { __typename: 'ComponentContentBlocksButton', id: string, url?: string | null, target?: Types.Enum_Componentcontentblocksbutton_Target | null, variant: Types.Enum_Componentcontentblocksbutton_Variant, size: Types.Enum_Componentcontentblocksbutton_Size, iconPosition?: Types.Enum_Componentcontentblocksbutton_Iconposition | null, iconFontAwesome?: string | null, cssClassNames?: string | null, uppercase?: boolean | null, buttonText: string } | { __typename: 'ComponentContentBlocksCard', id: string, title?: string | null, text?: string | null, titleCircleLetter?: string | null, overlayBadge?: string | null, paddingMobile?: Types.Enum_Componentcontentblockscard_Paddingmobile | null, paddingTablet?: Types.Enum_Componentcontentblockscard_Paddingtablet | null, paddingDesktop?: Types.Enum_Componentcontentblockscard_Paddingdesktop | null, cardBackground?: Types.Enum_Componentcontentblockscard_Background | null, cardCaption?: { __typename?: 'ComponentContentBlocksHeadline', id: string, mainTitle: string, titleType: Types.Enum_Componentcontentblocksheadline_Titletype, titleStyleType?: Types.Enum_Componentcontentblocksheadline_Titlestyletype | null, align?: Types.Enum_Componentcontentblocksheadline_Align | null, titleColor?: Types.Enum_Componentcontentblocksheadline_Titlecolor | null, fontWeight?: Types.Enum_Componentcontentblocksheadline_Fontweight | null, titleCssClassNames?: string | null, subtitle?: string | null, subtitleStyleType?: Types.Enum_Componentcontentblocksheadline_Subtitlestyletype | null, subtitleColor?: Types.Enum_Componentcontentblocksheadline_Subtitlecolor | null, subtitlePosition?: Types.Enum_Componentcontentblocksheadline_Subtitleposition | null, verticalSpacing?: Types.Enum_Componentcontentblocksheadline_Verticalpadding | null } | null, cardMedia?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, name: string, url: string, mime: string } | null }> } | null, buttons?: Array<{ __typename?: 'ComponentContentBlocksButton', id: string, text: string, url?: string | null, variant: Types.Enum_Componentcontentblocksbutton_Variant, size: Types.Enum_Componentcontentblocksbutton_Size, iconPosition?: Types.Enum_Componentcontentblocksbutton_Iconposition | null, iconFontAwesome?: string | null, cssClassNames?: string | null, uppercase?: boolean | null, target?: Types.Enum_Componentcontentblocksbutton_Target | null } | null> | null, setup?: { __typename?: 'ComponentContentBlocksContentBlockSetup', cssClassNames?: string | null, newColumn: boolean } | null } | { __typename: 'ComponentContentBlocksContentBlockSetup' } | { __typename: 'ComponentContentBlocksContentMedia', id: string, autoPlay?: boolean | null, muted?: boolean | null, loop?: boolean | null, controls?: boolean | null, imageLink?: string | null, media?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', name: string, caption?: string | null, alternativeText?: string | null, mime: string, url: string } | null }> } | null, setup?: { __typename?: 'ComponentContentBlocksContentBlockSetup', cssClassNames?: string | null } | null } | { __typename: 'ComponentContentBlocksContentText', id: string, text?: string | null, blockCssClassNames?: string | null, setup?: { __typename?: 'ComponentContentBlocksContentBlockSetup', cssClassNames?: string | null } | null, caption?: { __typename?: 'ComponentContentBlocksHeadline', mainTitle: string, titleType: Types.Enum_Componentcontentblocksheadline_Titletype, titleStyleType?: Types.Enum_Componentcontentblocksheadline_Titlestyletype | null, align?: Types.Enum_Componentcontentblocksheadline_Align | null, titleColor?: Types.Enum_Componentcontentblocksheadline_Titlecolor | null, fontWeight?: Types.Enum_Componentcontentblocksheadline_Fontweight | null, titleCssClassNames?: string | null, subtitle?: string | null, subtitleStyleType?: Types.Enum_Componentcontentblocksheadline_Subtitlestyletype | null, subtitleColor?: Types.Enum_Componentcontentblocksheadline_Subtitlecolor | null, subtitlePosition?: Types.Enum_Componentcontentblocksheadline_Subtitleposition | null, verticalSpacing?: Types.Enum_Componentcontentblocksheadline_Verticalpadding | null } | null, buttonLinks?: Array<{ __typename?: 'ComponentContentBlocksButton', id: string, text: string, url?: string | null, target?: Types.Enum_Componentcontentblocksbutton_Target | null, variant: Types.Enum_Componentcontentblocksbutton_Variant, size: Types.Enum_Componentcontentblocksbutton_Size, iconPosition?: Types.Enum_Componentcontentblocksbutton_Iconposition | null, iconFontAwesome?: string | null, cssClassNames?: string | null, uppercase?: boolean | null } | null> | null } | { __typename: 'ComponentContentBlocksHeadline', id: string, mainTitle: string, titleType: Types.Enum_Componentcontentblocksheadline_Titletype, titleStyleType?: Types.Enum_Componentcontentblocksheadline_Titlestyletype | null, align?: Types.Enum_Componentcontentblocksheadline_Align | null, titleColor?: Types.Enum_Componentcontentblocksheadline_Titlecolor | null, fontWeight?: Types.Enum_Componentcontentblocksheadline_Fontweight | null, titleCssClassNames?: string | null, subtitle?: string | null, subtitleStyleType?: Types.Enum_Componentcontentblocksheadline_Subtitlestyletype | null, subtitleColor?: Types.Enum_Componentcontentblocksheadline_Subtitlecolor | null, subtitlePosition?: Types.Enum_Componentcontentblocksheadline_Subtitleposition | null, verticalSpacing?: Types.Enum_Componentcontentblocksheadline_Verticalpadding | null } | { __typename: 'ComponentContentBlocksHeroBlock', id: string, subtitle?: string | null, titleFirstLine?: string | null, titleSecondLine?: string | null, briefText?: string | null, heroButtons?: Array<{ __typename?: 'ComponentContentBlocksButton', id: string, text: string, url?: string | null, variant: Types.Enum_Componentcontentblocksbutton_Variant, size: Types.Enum_Componentcontentblocksbutton_Size, iconPosition?: Types.Enum_Componentcontentblocksbutton_Iconposition | null, iconFontAwesome?: string | null, cssClassNames?: string | null, uppercase?: boolean | null, target?: Types.Enum_Componentcontentblocksbutton_Target | null } | null> | null, heroMedia?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, name: string, url: string, mime: string } | null } | null } | null } | { __typename: 'ComponentContentBlocksImageAndTextCard', id: string, text?: string | null, cardTitle: string, item?: Array<{ __typename?: 'ComponentListItemsListItems', id: string, textItem?: string | null } | null> | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, name: string, url: string, mime: string } | null } | null } } | { __typename: 'ComponentContentBlocksImageText', id: string, title?: string | null, itemText: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, name: string, url: string, mime: string } | null } | null }, button?: { __typename?: 'ComponentContentBlocksButton', id: string, text: string, url?: string | null, variant: Types.Enum_Componentcontentblocksbutton_Variant, size: Types.Enum_Componentcontentblocksbutton_Size, iconPosition?: Types.Enum_Componentcontentblocksbutton_Iconposition | null, iconFontAwesome?: string | null, cssClassNames?: string | null, uppercase?: boolean | null, target?: Types.Enum_Componentcontentblocksbutton_Target | null } | null } | { __typename: 'ComponentContentBlocksOverlay', id: string, text?: string | null, ctaButtons?: Array<{ __typename?: 'ComponentContentBlocksButton', id: string, text: string, url?: string | null, variant: Types.Enum_Componentcontentblocksbutton_Variant, size: Types.Enum_Componentcontentblocksbutton_Size, iconPosition?: Types.Enum_Componentcontentblocksbutton_Iconposition | null, iconFontAwesome?: string | null, cssClassNames?: string | null, uppercase?: boolean | null, target?: Types.Enum_Componentcontentblocksbutton_Target | null } | null> | null } | { __typename: 'ComponentContentBlocksPartnerContactBlock', name?: string | null } | { __typename: 'ComponentContentBlocksPartnersLocator', mapScreenshot?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, name: string, url: string, mime: string } | null } | null } | null } | { __typename: 'ComponentContentBlocksPointsWithCenterImage', id: string, type: Types.Enum_Componentcontentblockspointswithcenterimage_Type, centerImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, name: string, url: string, mime: string } | null } | null } | null, points?: Array<{ __typename?: 'ComponentContentBlocksPointsWithCenterImagePoint', id: string, label?: string | null, title?: string | null, text?: string | null } | null> | null } | { __typename: 'ComponentContentBlocksPricingCards', id: string, SinglePriceCard?: Array<{ __typename?: 'ComponentContentBlocksPriceCard', title?: string | null, price?: string | null, pack?: string | null, saving?: string | null, description?: string | null } | null> | null } | { __typename: 'ComponentContentBlocksProductsPromo', id: string, headerTitleLineOne?: string | null, headerTitleLineTwo?: string | null, headerButton?: { __typename?: 'ComponentContentBlocksButton', id: string, text: string, url?: string | null, variant: Types.Enum_Componentcontentblocksbutton_Variant, size: Types.Enum_Componentcontentblocksbutton_Size, iconPosition?: Types.Enum_Componentcontentblocksbutton_Iconposition | null, iconFontAwesome?: string | null, cssClassNames?: string | null, uppercase?: boolean | null, target?: Types.Enum_Componentcontentblocksbutton_Target | null } | null, products?: Array<{ __typename?: 'ComponentContentBlocksProductsPromoProduct', id: string, title?: string | null, featureList?: string | null, priceTitle?: string | null, price?: string | null, priceUnit?: string | null, buttonTitle?: string | null, buttonLink?: string | null, media?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, name: string, url: string, mime: string } | null } | null } | null } | null> | null } | { __typename: 'ComponentContentBlocksReviews', id: string, title?: string | null, reviewsVariant: Types.Enum_Componentcontentblocksreviews_Variant, reviews?: Array<{ __typename?: 'ComponentContentBlocksReviewsReview', id: string, reviewerName?: string | null, reviewerTitle?: string | null, rating?: number | null, reviewText?: string | null, reviewerPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, name: string, url: string, mime: string } | null } | null } | null } | null> | null } | { __typename: 'ComponentContentBlocksSpace', top?: Types.Enum_Componentcontentblocksspace_Top | null, bottom?: Types.Enum_Componentcontentblocksspace_Bottom | null, dividerColor?: Types.Enum_Componentcontentblocksspace_Dividercolor | null } | { __typename: 'ComponentContentBlocksStepCards' } | { __typename: 'ComponentContentBlocksStepperPartner', id: string, stepPartner: string, finished?: boolean | null, verticalMargin?: Types.Enum_Componentcontentblocksstepperpartner_Verticalmargin | null } | { __typename: 'ComponentContentBlocksVerticalStepper', id: string, step: string, finished?: boolean | null, gradient_to: Types.Enum_Componentcontentblocksverticalstepper_Gradient_To, gradient_via?: Types.Enum_Componentcontentblocksverticalstepper_Gradient_Via | null, stepperVariant?: Types.Enum_Componentcontentblocksverticalstepper_Variant | null } | { __typename: 'ComponentContentBlocksZoneSetup', id: string, background?: Types.Enum_Componentcontentblockszonesetup_Background | null, container: boolean, display?: Types.Enum_Componentcontentblockszonesetup_Display | null, columnsMobile: number, columnsTablet: number, columnsDesktop?: number | null, verticalPadding?: Types.Enum_Componentcontentblockszonesetup_Verticalpadding | null, maxWidth?: Types.Enum_Componentcontentblockszonesetup_Maxwidth | null, alignText?: Types.Enum_Componentcontentblockszonesetup_Aligntext | null, position?: Types.Enum_Componentcontentblockszonesetup_Position | null, gapHorizontal?: Types.Enum_Componentcontentblockszonesetup_Gaphorizontal | null, gapVertical?: Types.Enum_Componentcontentblockszonesetup_Gapvertical | null, newZone: boolean, alignItems?: Types.Enum_Componentcontentblockszonesetup_Alignitems | null, backgroundImageFull?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', name: string, caption?: string | null, alternativeText?: string | null, mime: string, url: string } | null } | null } | null } | { __typename: 'Error' } | null> | null } | null }> } | null };

export type CommonAttributesFragment = { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, name: string, url: string, mime: string };

export type MediaAttributesFragment = { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, name: string, url: string, mime: string } | null } | null };

export type ButtonAttributesFragment = { __typename?: 'ComponentContentBlocksButton', id: string, text: string, url?: string | null, variant: Types.Enum_Componentcontentblocksbutton_Variant, size: Types.Enum_Componentcontentblocksbutton_Size, iconPosition?: Types.Enum_Componentcontentblocksbutton_Iconposition | null, iconFontAwesome?: string | null, cssClassNames?: string | null, uppercase?: boolean | null, target?: Types.Enum_Componentcontentblocksbutton_Target | null };

export type HeadlineAttributesFragment = { __typename?: 'ComponentContentBlocksHeadline', id: string, mainTitle: string, titleType: Types.Enum_Componentcontentblocksheadline_Titletype, titleStyleType?: Types.Enum_Componentcontentblocksheadline_Titlestyletype | null, align?: Types.Enum_Componentcontentblocksheadline_Align | null, titleColor?: Types.Enum_Componentcontentblocksheadline_Titlecolor | null, fontWeight?: Types.Enum_Componentcontentblocksheadline_Fontweight | null, titleCssClassNames?: string | null, subtitle?: string | null, subtitleStyleType?: Types.Enum_Componentcontentblocksheadline_Subtitlestyletype | null, subtitleColor?: Types.Enum_Componentcontentblocksheadline_Subtitlecolor | null, subtitlePosition?: Types.Enum_Componentcontentblocksheadline_Subtitleposition | null, verticalSpacing?: Types.Enum_Componentcontentblocksheadline_Verticalpadding | null };

export const CommonAttributesFragmentDoc = gql`
    fragment CommonAttributes on UploadFile {
  alternativeText
  caption
  name
  url
  mime
}
    `;
export const MediaAttributesFragmentDoc = gql`
    fragment MediaAttributes on UploadFileEntityResponse {
  data {
    attributes {
      ...CommonAttributes
    }
  }
}
    ${CommonAttributesFragmentDoc}`;
export const ButtonAttributesFragmentDoc = gql`
    fragment ButtonAttributes on ComponentContentBlocksButton {
  id
  text
  url
  variant
  size
  iconPosition
  iconFontAwesome
  cssClassNames
  uppercase
  target
}
    `;
export const HeadlineAttributesFragmentDoc = gql`
    fragment HeadlineAttributes on ComponentContentBlocksHeadline {
  id
  mainTitle
  titleType
  titleStyleType
  align
  titleColor
  fontWeight
  titleCssClassNames
  subtitle
  subtitleStyleType
  subtitleColor
  subtitlePosition
  verticalSpacing: verticalPadding
}
    `;
export const PagesSlugsQueryDocument = gql`
    query pagesSlugsQuery {
  pages(pagination: {pageSize: 100}, locale: "all") {
    data {
      attributes {
        domain
        locale
        slug
      }
    }
  }
}
    `;

/**
 * __usePagesSlugsQueryQuery__
 *
 * To run a query within a React component, call `usePagesSlugsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesSlugsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesSlugsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePagesSlugsQueryQuery(baseOptions?: Apollo.QueryHookOptions<PagesSlugsQueryQuery, PagesSlugsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagesSlugsQueryQuery, PagesSlugsQueryQueryVariables>(PagesSlugsQueryDocument, options);
      }
export function usePagesSlugsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagesSlugsQueryQuery, PagesSlugsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagesSlugsQueryQuery, PagesSlugsQueryQueryVariables>(PagesSlugsQueryDocument, options);
        }
export function usePagesSlugsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PagesSlugsQueryQuery, PagesSlugsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagesSlugsQueryQuery, PagesSlugsQueryQueryVariables>(PagesSlugsQueryDocument, options);
        }
export type PagesSlugsQueryQueryHookResult = ReturnType<typeof usePagesSlugsQueryQuery>;
export type PagesSlugsQueryLazyQueryHookResult = ReturnType<typeof usePagesSlugsQueryLazyQuery>;
export type PagesSlugsQuerySuspenseQueryHookResult = ReturnType<typeof usePagesSlugsQuerySuspenseQuery>;
export type PagesSlugsQueryQueryResult = Apollo.QueryResult<PagesSlugsQueryQuery, PagesSlugsQueryQueryVariables>;
export const PagesDynamicContentQueryDocument = gql`
    query pagesDynamicContentQuery($domain: String!, $locale: I18NLocaleCode!, $slug: String!) {
  pages(locale: $locale, filters: {domain: {eq: $domain}, slug: {eq: $slug}}) {
    data {
      attributes {
        title
        domain
        locale
        slug
        zoneSetup {
          id
          background
          container
          display
          columnsMobile
          columnsTablet
          columnsDesktop
          verticalPadding
          maxWidth
          alignText
          position
          newZone
          backgroundImageFull {
            ...MediaAttributes
          }
        }
        dynamicZone {
          __typename
          ... on ComponentContentBlocksCard {
            id
            title
            text
            cardCaption: caption {
              ...HeadlineAttributes
            }
            cardMedia: media {
              data {
                attributes {
                  alternativeText
                  caption
                  name
                  url
                  mime
                }
              }
            }
            buttons {
              ...ButtonAttributes
            }
            titleCircleLetter
            setup {
              cssClassNames
              newColumn
            }
            overlayBadge
            paddingMobile
            paddingTablet
            paddingDesktop
            cardBackground: background
          }
          ...VerticalStepper
          ... on ComponentContentBlocksHeadline {
            id
            mainTitle
            titleType
            titleStyleType
            align
            titleColor
            fontWeight
            titleCssClassNames
            subtitle
            subtitleStyleType
            subtitleColor
            subtitlePosition
            verticalSpacing: verticalPadding
          }
          ... on ComponentContentBlocksZoneSetup {
            id
            background
            container
            display
            columnsMobile
            columnsTablet
            columnsDesktop
            verticalPadding
            maxWidth
            alignText
            position
            gapHorizontal
            gapVertical
            newZone
            alignItems
            backgroundImageFull {
              data {
                attributes {
                  name
                  caption
                  alternativeText
                  mime
                  url
                }
              }
            }
          }
          ... on ComponentContentBlocksContentText {
            id
            text
            setup {
              cssClassNames
            }
            caption {
              mainTitle
              titleType
              titleStyleType
              align
              titleColor
              fontWeight
              titleCssClassNames
              subtitle
              subtitleStyleType
              subtitleColor
              subtitlePosition
              verticalSpacing: verticalPadding
            }
            buttonLinks {
              id
              text
              url
              target
              variant
              size
              iconPosition
              iconFontAwesome
              cssClassNames
              uppercase
            }
            blockCssClassNames
          }
          ... on ComponentContentBlocksContentMedia {
            id
            media {
              data {
                attributes {
                  name
                  caption
                  alternativeText
                  mime
                  url
                }
              }
            }
            autoPlay
            muted
            loop
            controls
            imageLink
            setup {
              cssClassNames
            }
          }
          ... on ComponentContentBlocksOverlay {
            id
            text
            ctaButtons {
              ...ButtonAttributes
            }
          }
          ... on ComponentContentBlocksSpace {
            top
            bottom
            dividerColor
          }
          ... on ComponentContentBlocksPointsWithCenterImage {
            id
            type
            centerImage {
              data {
                attributes {
                  alternativeText
                  caption
                  name
                  url
                  mime
                }
              }
            }
            points {
              id
              label
              title
              text
            }
          }
          ... on ComponentContentBlocksButton {
            id
            buttonText: text
            url
            target
            variant
            size
            iconPosition
            iconFontAwesome
            cssClassNames
            uppercase
          }
          ... on ComponentContentBlocksHeroBlock {
            id
            subtitle
            titleFirstLine
            titleSecondLine
            briefText
            heroButtons {
              ...ButtonAttributes
            }
            heroMedia {
              ...MediaAttributes
            }
          }
          ... on ComponentContentBlocksProductsPromo {
            id
            headerTitleLineOne
            headerTitleLineTwo
            headerButton {
              ...ButtonAttributes
            }
            products {
              id
              title
              featureList
              media {
                ...MediaAttributes
              }
              priceTitle
              price
              priceUnit
              buttonTitle
              buttonLink
            }
          }
          ...Reviews
          ... on ComponentContentBlocksPartnersLocator {
            mapScreenshot {
              data {
                id
                attributes {
                  alternativeText
                  caption
                  name
                  url
                  mime
                }
              }
            }
          }
          ... on ComponentContentBlocksAccordion {
            id
            accordionTitle: title
            description
            triggerClassNames
          }
          ... on ComponentContentBlocksImageAndTextCard {
            id
            cardTitle: title
            text
            item {
              id
              textItem
            }
            image {
              data {
                id
                attributes {
                  alternativeText
                  caption
                  name
                  url
                  mime
                }
              }
            }
          }
          ...Reviews
          ... on ComponentContentBlocksPricingCards {
            id
            SinglePriceCard {
              ...SinglePriceCard
            }
          }
          ... on ComponentContentBlocksPartnerContactBlock {
            name
          }
          ... on ComponentContentBlocksImageText {
            id
            image {
              data {
                id
                attributes {
                  alternativeText
                  caption
                  name
                  url
                  mime
                }
              }
            }
            title
            itemText: text
            button {
              id
              text
              url
              variant
              size
              iconPosition
              iconFontAwesome
              cssClassNames
              uppercase
              target
            }
          }
          ... on ComponentContentBlocksStepperPartner {
            id
            stepPartner
            finished
            verticalMargin
          }
        }
      }
    }
  }
}
    ${MediaAttributesFragmentDoc}
${HeadlineAttributesFragmentDoc}
${ButtonAttributesFragmentDoc}
${VerticalStepperFragmentDoc}
${ReviewsFragmentDoc}
${SinglePriceCardFragmentDoc}`;

/**
 * __usePagesDynamicContentQueryQuery__
 *
 * To run a query within a React component, call `usePagesDynamicContentQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesDynamicContentQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesDynamicContentQueryQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *      locale: // value for 'locale'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePagesDynamicContentQueryQuery(baseOptions: Apollo.QueryHookOptions<PagesDynamicContentQueryQuery, PagesDynamicContentQueryQueryVariables> & ({ variables: PagesDynamicContentQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagesDynamicContentQueryQuery, PagesDynamicContentQueryQueryVariables>(PagesDynamicContentQueryDocument, options);
      }
export function usePagesDynamicContentQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagesDynamicContentQueryQuery, PagesDynamicContentQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagesDynamicContentQueryQuery, PagesDynamicContentQueryQueryVariables>(PagesDynamicContentQueryDocument, options);
        }
export function usePagesDynamicContentQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PagesDynamicContentQueryQuery, PagesDynamicContentQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagesDynamicContentQueryQuery, PagesDynamicContentQueryQueryVariables>(PagesDynamicContentQueryDocument, options);
        }
export type PagesDynamicContentQueryQueryHookResult = ReturnType<typeof usePagesDynamicContentQueryQuery>;
export type PagesDynamicContentQueryLazyQueryHookResult = ReturnType<typeof usePagesDynamicContentQueryLazyQuery>;
export type PagesDynamicContentQuerySuspenseQueryHookResult = ReturnType<typeof usePagesDynamicContentQuerySuspenseQuery>;
export type PagesDynamicContentQueryQueryResult = Apollo.QueryResult<PagesDynamicContentQueryQuery, PagesDynamicContentQueryQueryVariables>;